import { useQuery } from '@tanstack/react-query'
import { getCurrentOrders } from '../../../services/Order/Order.service'
import useUser from '../../Shared/UserProvider/useUser'

const useCurrentOrders = () => {
    const {user} = useUser()
    const { data: orders, refetch } = useQuery({
        queryFn: getCurrentOrders,
        queryKey: ['orders', 'current'],
        refetchInterval: 30000,
        enabled: !user.isLoggedInOwnScope
    })

    return {
        orders,
        refetchCurrentOrders: refetch,
    }
}

export { useCurrentOrders }
